import React, { useState } from "react";
import { Collapse, GridLegacy, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper";
import FormFile from "../../../../components/Forms/FormFile";
import CardBody from "../../../../components/Card/CardBody";
import Allergens from "../Allergens";
import Card from "../../../../components/Card/Card";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import { ImageResolutionHint } from "../../../../components/ImageHints/ImageResolutionHint";
import { useFormContext, useWatch } from "react-hook-form";
import { CustomizableTexts } from "../../../../components/CustomizableTexts/CustomizableTexts";
import { FilterRibbon } from "../../../../components/FilterRibbon/FilterRibbon";
import Checkbox from "@mui/material/Checkbox";
import AuthenticationWrapper from "../../../../../beheer/auth/AuthenticationWrapper";
import FormControlledInputTC from "../../../../components/Forms/FormControlledInputTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import { ExitAppCard } from "../Tablet.tsx";

export const namedJamezzFiles: {
  name: string;
  type: "image" | "file";
  res: string;
  tKey?: string;
  tDefault?: string;
}[] = [
  { name: "extra_settings__qrv5_logo_top_bar", type: "image", res: "72x40" },
  { name: "extra_settings__qrv5_logo_floating_action_button", type: "image", res: "30x30" },
  { name: "extra_settings__qrv5_background_of_order_page", type: "file", res: "390x844" },
  { name: "extra_settings__qrv5_background_of_checkout_page", type: "file", res: "390x844" },
  { name: "extra_settings__qrv5_background_of_return_page", type: "file", res: "390x844" },
  { name: "extra_settings__qrv5_menu_header", type: "image", res: "390x200" },
  { name: "extra_settings__qrv5_article_page_background", type: "image", res: "390x844" },
  { name: "extra_settings__qrv5_topbar_background", type: "image", res: "390x60" },
  { name: "extra_settings__qrv5_drinks_background", type: "image", res: "195x48" },
  { name: "extra_settings__qrv5_food_background", type: "image", res: "195x48" },
  { name: "extra_settings__qrv5_list_of_menus_background", type: "image", res: "390x48" },
  { name: "extra_settings__qrv5_menu_content_background", type: "image", res: "390x650" },
  {
    name: "loginBackground",
    type: "image",
    res: "1600x900", // 16:9
    tKey: "vestigingen.form.branding.label.loginBackground",
    tDefault: "Achtergrond login",
  },
  // 844 - 40 - 60 - 96
];

//FilterRibbon information
export const ribbonComponents = [
  {
    screenTitle: "All",
    screenIndex: "none",
    screenImage: "",
    screenWidth: 108,
    screenHeight: 192,
  },
  {
    screenTitle: "Categories",
    screenIndex: "1",
    screenImage: "/img/customComponents/FilrterRibbon_CATEGORY_QR_Original_002.png",
    screenDescription: "Categories and products screen",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "Categories",
        screenIndex: "1E",
        screenImage: "",
        screenDescription: "Top or side category selection",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 34,
        areaPositionY: 57,
        areaPositionX: 0,
      },
      {
        screenTitle: "Categories",
        screenIndex: "1A",
        screenImage: "",
        screenDescription: "Top or side category selection",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 18,
        areaPositionY: 0,
        areaPositionX: 0,
      },
      {
        screenTitle: "Categories",
        screenIndex: "1D",
        screenImage: "",
        screenDescription: "Category header image",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 35,
        areaPositionY: 20,
        areaPositionX: 0,
      },
      {
        screenTitle: "Products",
        screenIndex: "1B",
        screenImage: "",
        screenDescription: "Displayed products of selected category",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 72,
        areaPositionY: 93,
        areaPositionX: 0,
      },
      {
        screenTitle: "Cart button",
        screenIndex: "1C",
        screenImage: "",
        screenDescription: "Button to navigate to shopping cart screen",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 30,
        areaHeight: 23,
        areaPositionY: 167,
        areaPositionX: 73,
      },
    ],
  },
  {
    screenTitle: "Article",
    screenIndex: "2",
    screenImage: "/img/customComponents/FilterRibbon_Product_002.png",
    screenDescription: "Article detail page - add to shopping cart",
    screenWidth: 108,
    screenHeight: 192,
  },
  {
    screenTitle: "Cart",
    screenIndex: "3",
    screenImage: "/img/customComponents/FilterRibbon_Cart_001-FullHD.png",
    screenDescription: "List of total amount of ordered products and prices",
    screenWidth: 108,
    screenHeight: 192,
  },
  {
    screenTitle: "Pay",
    screenIndex: "4",
    screenImage: "/img/customComponents/FilterRibbon_Pay_003-FullHD.png",
    screenDescription: "The final payment screen",
    screenWidth: 108,
    screenHeight: 192,
  },
  {
    screenTitle: "Return",
    screenIndex: "5",
    screenImage: "/img/customComponents/FilterRibbon_Return_001-FullHD.png",
    screenDescription: "Return screen after payment",
    screenWidth: 108,
    screenHeight: 192,
    subScreenInfo: [
      {
        screenTitle: "Return header",
        screenIndex: "5A",
        screenImage: "",
        screenDescription: "Top heading",
        screenWidth: 108,
        screenHeight: 192,
        areaWidth: 108,
        areaHeight: 16,
        areaPositionY: 0,
        areaPositionX: 0,
      },
    ],
  },
];
const translatableTexts = [
  "checkout button",
  "go to order button",
  "pay button",
  "order button",
  "order_article_page_back_button",
  "order_dispatch_error",
  "no timeslots available message",
];

export default function QrV5() {
  const { vestigingId } = useFormContext();
  const paymentsActive = useWatch({ name: "payDirect" });
  const [selectedGroupVal, setSelectedGroupVal] = useState("none");
  const [showAdminValues, setShowAdminValues] = useState(false);

  const toggleAdminMode = () => {
    setShowAdminValues(!showAdminValues);
  };

  const changeSelector = (newSelector) => {
    setSelectedGroupVal(newSelector);
  };

  const translatedAdminEditMode = getTranslation("QrV5_SortingRibbon.Admin_edit_mode", "not found");

  const listOfInactiveAreas = translatedAdminEditMode.slice(
    translatedAdminEditMode.indexOf("["),
    translatedAdminEditMode.lastIndexOf("]") + 1
  );

  const translatedAdminEditModeText = translatedAdminEditMode.replace(listOfInactiveAreas, "");
  const sharedShoppingCartEnabled = useWatch({ name: "custom_data.qrv5.shared_shopping_cart.enabled" });
  const mediaUrls = useWatch({ name: "media_urls" });

  return (
    <>
      <Card>
        <CardBody>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper tDefault={"Qr V5 settings"} tKey={"vestigingen.form.algemeen.headers.qrv5"} />
            </h3>
          </GridLegacy>
          <FormTextTC name={"start_url"} tDefault={"Home Page Url (e.g. mastercode)"} tKey={"vestiging.start_url"} />
          <FormSwitchTC name={"extra_settings__voucherShowKeyboard"} tKey={"Show Voucher button"} />
          {/*  <Tooltip
            title={
              <TranslationWrapper
                tKey={"vestigingen.form.algemeen.headers.shared_cart_disabled_paymnents"}
                tDefault={"Shared shopping cart is not available when payments are enabled."}
              />
            }
            placement="bottom"
          >*/}
          <FormSwitchTC
            disabled={paymentsActive}
            name={"custom_data.qrv5.shared_shopping_cart.enabled"}
            tDefault={"Is shared shopping cart enabled?"}
            tKey={"shared_shopping_cart_enabled"}
            tooltip={
              <TranslationWrapper
                tDefault={"Shared shopping cart is not available when payments are enabled."}
                tKey={"vestigingen.form.algemeen.headers.shared_cart_disabled_paymnents"}
              />
            }
          />
          <FormSwitchTC
            name={"custom_data.appv5.allow_item_notes"}
            tDefault={"Allow item notes?"}
            tKey={"custom_data.appv5.allow_item_notes"}
            defaultValue={false}
          />
          {/*</Tooltip>*/}
          <Collapse in={!!sharedShoppingCartEnabled}>
            <FormControlledInputTC
              defaultValue={15}
              name={"custom_data.qrv5.shared_shopping_cart.timer_seconds"}
              rules={{
                min: {
                  value: 5,
                  message: <TranslationWrapper tKey={"The value must be equal or higher than 5!"} />,
                },
              }}
              tDefault={"How many seconds must be waited before sending the shared shopping cart?"}
              tKey={"shared_shopping_cart_timer_seconds"}
              type={"number"}
            />
          </Collapse>
        </CardBody>
      </Card>
      <ExitAppCard />
      <Card>
        <CardBody>
          <GridLegacy container>
            <GridLegacy item md={6} xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Qr app images"} tKey={"vestigingen.form.algemeen.headers.qr.images"} />
              </h3>
            </GridLegacy>

            <AuthenticationWrapper
              child={(write) => (
                <GridLegacy
                  item
                  md={6}
                  style={{ marginBottom: 10, marginTop: 15, display: "flex", alignItems: "center" }}
                  xs={12}
                >
                  <Checkbox
                    checked={showAdminValues}
                    color={"primary"}
                    onChange={toggleAdminMode}
                    size={"small"}
                    style={{ width: 50, height: 50 }}
                  />

                  {showAdminValues || listOfInactiveAreas === "" ? (
                    <TranslationWrapper tDefault={"Admin edit mode"} tKey={"KioskV5_SortingRibbon.Admin_edit_mode"} />
                  ) : (
                    <Typography>{translatedAdminEditModeText}</Typography>
                  )}
                </GridLegacy>
              )}
              permissionKey={"brandingdesign.customcomponents.admineditmode"}
            />
          </GridLegacy>

          <FilterRibbon
            allSelectedFilterText={"Show all images"}
            areaHighlightBackground={"#000000"}
            areaHighlightBackgroundOpacity={175}
            areaOpacity={100}
            changeSelector={changeSelector} //** Important
            colorGroup1Background={"#f46e26"}
            colorGroup1Foreground={"#ffffff"}
            colorGroup2Background={"#ffffff"}
            colorGroup2Foreground={"#000000"}
            colorGroup3Background={"#f46e26"}
            colorGroup3Foreground={"#ffffff"}
            inactiveAreaColor={"#FF0000"}
            inactiveAreas={listOfInactiveAreas}
            ribbonComponents={ribbonComponents} //** Important
            selectedGroupVal={selectedGroupVal} //** Important
            showAdminInfo={showAdminValues}
            showBreadcrumbs={false}
            showFilterReturnButton={true}
            showHoverDescription={true}
            shownDescription={"none"} // options: side, bottom (default), none
          />

          <GridLegacy container>
            {namedJamezzFiles.map((namedJamezzFile) => {
              const translatedImageTitle = getTranslation(`vestigingen.form.zuil.label.${namedJamezzFile.name}`);

              const screenIndex = translatedImageTitle.slice(
                translatedImageTitle.indexOf("["),
                translatedImageTitle.lastIndexOf("]") + 1
              );

              const errorColor =
                showAdminValues &&
                (translatedImageTitle === "notfound" ||
                  (!translatedImageTitle.includes("[") && !translatedImageTitle.includes("[")))
                  ? { color: "red" }
                  : undefined;

              if (screenIndex.includes(selectedGroupVal) || selectedGroupVal === "none") {
                return (
                  <GridLegacy item key={namedJamezzFile.name} style={errorColor} xs={4}>
                    {showAdminValues ? (
                      <TranslationWrapper
                        tDefault={namedJamezzFile.name}
                        tKey={`vestigingen.form.zuil.label.${namedJamezzFile.name}`}
                      />
                    ) : namedJamezzFile.tKey && namedJamezzFile.tDefault ? (
                      <p style={{ margin: 0 }}>
                        <TranslationWrapper tDefault={namedJamezzFile.tDefault} tKey={namedJamezzFile.tKey} />
                      </p>
                    ) : (
                      <p style={{ margin: 0 }}>{namedJamezzFile.name}</p>
                    )}
                    <ImageResolutionHint res={namedJamezzFile.res} />
                    <FormFile
                      canCrop={false}
                      imgurl={mediaUrls?.[`extra_settings__${namedJamezzFile.name}`]?.[0]?.conversions?.optimized?.url}
                      name={namedJamezzFile.name}
                      nullable={true}
                      originalUrl={mediaUrls?.[`extra_settings__${namedJamezzFile.name}`]?.[0]?.original}
                      type={namedJamezzFile.type}
                    />
                  </GridLegacy>
                );
              }
            })}
          </GridLegacy>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Custom texts"} tKey={"vestigingen.form.algemeen.headers.qrv5.text"} />
          </h3>
          <h4>
            <TranslationWrapper
              tDefault={"Order and Checkout"}
              tKey={"vestigingen.form.algemeen.headers.qrv5.custom_texts.order_and_checkout"}
            />
          </h4>
          <CustomizableTexts translatableTexts={translatableTexts} vestigingId={vestigingId} />
        </CardBody>
      </Card>

      <Allergens />
    </>
  );
}
